import { useTranslation } from 'react-i18next'
import { EmailVerificationForm } from '@/components/features/auth'

export function VerifyEmailPage() {
  const { t } = useTranslation('auth')

  return (
    <div className="w-full max-w-md">
      <div className="mb-8 text-center">
        <h1 className="text-2xl font-bold">{t('verifyEmailTitle')}</h1>
        <p className="text-muted-foreground">{t('verifyEmailSubtitle')}</p>
      </div>
      <EmailVerificationForm />
    </div>
  )
}
